import { HelpCircle, LifeBuoy } from "lucide-react";
import { Assistant, Flow, Quick, QuickReplies } from "./FlowParts";

// First thing a visitor sees: a greeting and conversational choices (My Conversations lives in the panel header). No form, no questions
// about identity (FAQ browsing is anonymous).
export default function WelcomeView({ c }) {
  const { g, mode } = c;
  const pending = mode === "pending";
  return (
    <Flow g={g} scrollKey="welcome">
      <Assistant g={g}>
        <p className="lc-flow-title">{g.welcomeTitle}</p>
        <p>{g.welcomeBody}</p>
      </Assistant>
      <QuickReplies label={g.welcomeBody}>
        <Quick primary icon={<HelpCircle size={16} aria-hidden="true" />} onClick={c.showFaq} disabled={pending}>{g.commonQuestions}</Quick>
        <Quick primary icon={<LifeBuoy size={16} aria-hidden="true" />} onClick={() => c.startIntake()} disabled={pending}>{g.contactSupport}</Quick>
      </QuickReplies>
    </Flow>
  );
}
